import React from 'react';
import type { ElementRef, Ref, ReactNode } from 'react';

import { styled } from '@backyard-ui/styles';
import type { StitchesCSS } from '@backyard-ui/styles';

import styles from './Tag.styles';

export interface TagProps {
  /**
   * Stitches `css` func
   */
  css?: StitchesCSS;

  /**
   * The ref to the HTML DOM element
   */
  ref?: Ref<HTMLDivElement>;

  /**
   * The children elements
   */
  children: ReactNode;
}

const TagEl = styled('div', styles);

const Tag = React.forwardRef<ElementRef<typeof TagEl>, TagProps>(
  (props, ref) => {
    return <TagEl ref={ref} {...props} />;
  }
);

Tag.displayName = 'Tag';

export default Tag;
